@if (header()) {
  <app-viewer class="lens-header" [text]="header()" />
}
  @if (query.responseOf()) {
    <div class="list-container responses-of">
      <div class="label" i18n>Responses Of:</div>
      <app-ref class="full-page"
               [ref]="query.responseOf()"
               [showToggle]="true"
               (copied)="query.refresh()" />
    </div>
  }
  @if (query.sourcesOf()) {
    <div class="list-container sources-of">
      <div class="label" i18n>Sources Of:</div>
      <app-ref class="full-page"
               [ref]="query.sourcesOf()"
               [showToggle]="true"
               (copied)="query.refresh()" />
    </div>
  }
@if (isTemplate('graph')) {
  @defer {
    <app-force-directed #lens
                        [tag]="tag()"
                        [content]="page()?.content || []" />
  } @placeholder {
    <app-loading />
  }
} @else if (isTemplate('grid')) {
  @defer {
    <app-grid #lens
              [tag]="tag()"
              [ext]="ext()!"
              [page]="page()"
              [pageControls]="pageControls()"
              [cols]="cols()" />
  } @placeholder {
    <app-loading />
  }
} @else if (isTemplate('notes')) {
  <app-notebook #lens
                [class]="cssClass(ext()?.tag)"
                [ext]="ext()"
                [page]="page()"
                [pageControls]="pageControls()"
                [plugins]="plugins()"
                [cols]="cols()" />
} @else if (isTemplate('kanban')) {
  <app-kanban #lens
              [query]="tag()"
              [ext]="ext()!"
              [fullPage]="fullPage()"
              [pageControls]="pageControls()"
              [size]="size()"
              [sort]="sort()"
              [filter]="filter()"
              [search]="search()" />
} @else if (isTemplate('blog')) {
  <app-blog #lens
            [ext]="ext()!"
            [page]="page()"
            [pageControls]="pageControls()"
            [cols]="cols()" />
} @else if (isTemplate('chat')) {
  <app-chat #lens
            [query]="tag()" />
} @else if (isTemplate('map')) {
  @defer {
    <app-map #lens
             [tag]="tag()"
             [ext]="ext()"
             [page]="page()"
             [saveView]="fullPage()"
             [pageControls]="pageControls()" />
  } @placeholder {
    <app-loading />
  }
} @else if (isTemplate('folder')) {
  <app-folder #lens
              [page]="page()"
              [tag]="tag()"
              [ext]="ext()!" />
} @else {
  <app-ref-list #lens
                class="expand"
                [class]="cssClass(ext()?.tag)"
                [ext]="ext()"
                [page]="page()"
                [pageControls]="pageControls()"
                [plugins]="plugins()"
                [cols]="cols()"
                [showAlarm]="showAlarm()"
                [showVotes]="showVotes()" />
}
